// src/App.tsx
import { Routes, Route } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";

const App = () => {
  return (
    <Routes>
      {/* 1) The login page(s) */}
      <Route path="/inicio-sesion/*" element={<AuthLayout />} />

      {/* 2) Everything else => Admin layout (which includes your sidebar, etc.) */}
      <Route path="/*" element={<AdminLayout />} />
    </Routes>
  );
};

export default App;
